<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	import { postReq } from '../../../services/http';
	//Stores
	import { user_data } from 'src/stores/account/user';
import { wearables_connected } from 'src/stores/session/native-bridge';
	//Design system components
	import { Button, Text, toast } from '@Shelly/shelly-design-system';
	import { init_wearables_android } from '../../../services/native_container_requests_android';
	import { capFirstChar } from 'src/helpers/utilities';

	$: disabled = $wearables_connected == 0 || $user_data?.installer;

	const handleWearablesSettings = () => {
		console.log('Open Android wearables settings');
		init_wearables_android();
	};
</script>

<Text class="mb-l"
	>{$format('wearables_descriptions', {
		default: 'Currently connected wearable devices:',
	}) +
		' ' +
		$wearables_connected}
</Text>

<Button size="m" class="width-md-auto width-sm-full" {disabled} on:click={handleWearablesSettings}
	>{capFirstChar($format('add_devices', { default: 'add devices' }))}</Button
>
